import type { Capability } from '@taler/api-client'

/** The one place this feature's view gate is written; the page and the nav both call it. */
export function canViewTransfers(can: (capability: Capability) => boolean): boolean {
  return can('TRANSFER')
}
